(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(function() {
  const searchInput = document.querySelector('[data-predictive-search-input]');
  const resultsContainer = document.querySelector('[data-predictive-search-results]');
  const productsContainer = document.querySelector('[data-predictive-search-products]');
  const loadingIndicator = document.querySelector('[data-predictive-search-loading]');
  const viewAllLink = document.querySelector('[data-predictive-search-view-all]');
  
  if (!searchInput || !resultsContainer) return;
  
  let debounceTimer;
  let currentQuery = '';
  
  searchInput.addEventListener('input', function(e) {
    const query = e.target.value.trim();
    
    clearTimeout(debounceTimer);
    
    if (query.length < 2) {
      resultsContainer.hidden = true;
      return;
    }
    
    debounceTimer = setTimeout(() => {
      if (query !== currentQuery) {
        currentQuery = query;
        performSearch(query);
      }
    }, 300);
  });
  
  searchInput.addEventListener('focus', function() {
    if (currentQuery.length >= 2) {
      resultsContainer.hidden = false;
    }
  });
  
  document.addEventListener('click', function(e) {
    if (!e.target.closest('.lcars-header__search-wrapper')) {
      resultsContainer.hidden = true;
    }
  });
  
  async function performSearch(query) {
    loadingIndicator.hidden = false;
    resultsContainer.hidden = false;
    productsContainer.innerHTML = '';
    viewAllLink.hidden = true;
    
    try {
      const response = await fetch(
        `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=5`
      );
      const data = await response.json();
      
      loadingIndicator.hidden = true;
      
      if (data.resources?.results?.products?.length > 0) {
        renderProducts(data.resources.results.products);
        viewAllLink.href = `/search?q=${encodeURIComponent(query)}`;
        viewAllLink.hidden = false;
      } else {
        productsContainer.innerHTML = '<div class="lcars-header__search-empty">No results found</div>';
      }
    } catch (error) {
      loadingIndicator.hidden = true;
      productsContainer.innerHTML = '<div class="lcars-header__search-empty">Search unavailable</div>';
    }
  }
  
  function renderProducts(products) {
    productsContainer.innerHTML = products.map(product => `
      <a href="${product.url}" class="lcars-header__search-item">
        ${product.featured_image?.url ? `
          <img src="${product.featured_image.url}&width=60" alt="${product.title}" class="lcars-header__search-item-img">
        ` : '<div class="lcars-header__search-item-img lcars-header__search-item-img--placeholder"></div>'}
        <div class="lcars-header__search-item-info">
          <span class="lcars-header__search-item-title">${product.title.toUpperCase()}</span>
          <span class="lcars-header__search-item-price">${formatMoney(product.price)}</span>
        </div>
      </a>
    `).join('');
  }
  
  function formatMoney(cents) {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: window.Shopify?.currency?.active || 'USD'
    }).format(cents / 100);
  }
})();

  } catch(e) { console.error(e); }
})();
})();
